const pageNameKey = "otaDrawerMarkDownSupport";

export const otaDrawerMarkDownSupportEn = {
  [pageNameKey]: {
    documentationText: "Documentation",
    markDownSupportedText: "Markdown supported",
  },
};

export const otaDrawerMarkDownSupportPtBr = {
  [pageNameKey]: {
    documentationText: "Documentação",
    markDownSupportedText: "Suporte a Markdown",
  },
};

export const otaDrawerMarkDownSupportDe = {
  [pageNameKey]: {
    documentationText: "Dokumentation",
    markDownSupportedText: "Markdown unterstützt",
  },
};

export const otaDrawerMarkDownSupportZhHans = {
  [pageNameKey]: {
    documentationText: "文档",
    markDownSupportedText: "支持降价",
  },
};

export const otaDrawerMarkDownSupportIt = {
  [pageNameKey]: {
    documentationText: "Documentazione",
    markDownSupportedText: "Markdown supportato",
  },
};

export const otaDrawerMarkDownSupportEs = {
  [pageNameKey]: {
    documentationText: "Documentación",
    markDownSupportedText: "Compatible con Markdown",
  },
};

export const otaDrawerMarkDownSupportNl = {
  [pageNameKey]: {
    documentationText: "Documentatie",
    markDownSupportedText: "Markdown wordt ondersteund",
  },
};

export const otaDrawerMarkDownSupportTr = {
  [pageNameKey]: {
    documentationText: "Dokümantasyon",
    markDownSupportedText: "Markdown destekleniyor",
  },
};
